export default {
  init() {
    // JavaScript to be fired on the draw pages
    $(document).ready(function () {
      $('input#wpsl-search-input').attr('placeholder', 'ZIP code')
      $('div#wpsl-stores > ul').addClass('active');
      $('div#wpsl-stores').prepend('<em style="padding-bottom: 10px; display: block;" class="uk-text-small note">* Please call the lab of your choice in advance to determine if this location accepts walk-ins or is by appointment only. Myriad kits may be available at some sites. </em><div class="title-search-wrap"></div>')
      $('div#wpsl-stores').append('<div class="walkin-mobile-tabs"><a class="show-walkin active">On-site locations</a><a class="show-mobile">Mobile Phlebotomy</a></div><div class="mobile-phleb-cover bg-white "><em class="uk-display-block uk-text-small">* Mobile phlebotomy vendors will not show up on the map</em><div class="mobile-list"><li><div class="wpsl-store-location"><p><span class="uk-text-small">Call to verify vendor services your area</span></p><p><a class="uk-text-medium" target="_blank" href="https://phlebfinders.com/myriad-request/">Phleb-Finders</a></p><p><a href="tel:8552363031">(855) 236-3031</a></p><p><a rel="noreferrer noopener" target="_blank" href="https://phlebfinders.com/myriad-request/">https://phlebfinders.com/myriad-request/</a></p><p>Nationwide</p></div></li><li><div class="wpsl-store-location"><p><a class="uk-text-medium" target="_blank" href="https://www.travalab.com/myriad">TravaLab</a></p><p><span class="uk-text-small">Call to verify vendor services your area</span></p><p><a href="tel:8009216933">(800) 921-6933</a></p><p><a rel="noreferrer noopener" target="_blank" href="https://www.travalab.com/myriad">https://www.travalab.com/myriad</a></p><p>Nationwide</p></div></li></div></div>')

      $('.walkin-mobile-tabs a').click(function (e) {
        e.preventDefault();
        $('.mobile-phleb-cover, div#wpsl-stores > ul').toggleClass('active')
        $('.walkin-mobile-tabs a').toggleClass('active');
      })

      $('#wpsl-search-input').on('change', function () {
        $.ajax({
          url: window.location.origin + '/draw/wp-admin/admin-ajax.php',
          type: 'POST',
          dataType: 'html',
          data: {
            action: 'mobile_phleb_vendor_loop',
            zip: $(this).val(),
          },
          success: function (res) {
            if (res) {
              $('.mobile-phleb-cover div').html(res)

            } else {
              $('.mobile-phleb-cover div').html('<div>There are no mobile phlebotomy vendors in that area</div>')
            }
          },
          error: function (err) {
            console.log('error: ' + err);
          },
        })
      })

    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/bloodDrawLocator.js